import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { HiArrowRight } from "react-icons/hi";
import { images } from "../../constants";
import { reveal } from "../../components";

const contactLinks = [
  {
    group: "Reach Us Directly",
    items: [
      { label: "Email", value: "hyphentechinfo@gmail.com", href: "mailto:hyphentechinfo@gmail.com" },
      { label: "WhatsApp", value: "+257 76 93 59 25", href: "https://wa.me/25762674277" },
    ],
  },
  {
    group: "Follow Our Journey",
    items: [
      { label: "LinkedIn", value: "Hyphen Tech", href: "https://www.linkedin.com/company/hyphen-tech-1" },
      {
        label: "Facebook",
        value: "Hyphen Tech",
        href: "https://www.facebook.com/profile.php?id=100064389290696",
      },
    ],
  },
];

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer
      id="contact"
      className="on-deep w-full bg-paper-deep text-[color:var(--ink-invert)]"
    >
      <div className="shell py-24 md:py-32">

        {/* ── The ask ── */}
        <motion.div {...reveal()} className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <div className="lg:col-span-8">
            <span className="label text-gold">
              {t("Ready to transform your business?")}
            </span>
            <h2 className="display-hero mt-6">
              {t("Let's build something")}
              <br />
              <em>{t("exceptional")}</em> {t("together")}
              <span className="text-gold">.</span>
            </h2>
          </div>
          <div className="lg:col-span-4 lg:pb-4">
            <a href="mailto:hyphentechinfo@gmail.com" className="btn btn-gold">
              {t("Get In Touch")}
              <HiArrowRight aria-hidden />
            </a>
          </div>
        </motion.div>

        {/* ── Details ── */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14 mt-20 md:mt-28 pt-12 border-t border-[color:var(--rule-invert)]">
          {contactLinks.map((column, i) => (
            <motion.div key={column.group} {...reveal(i)} className="md:col-span-4">
              <p className="label text-white/45">{t(column.group)}</p>
              <ul className="mt-5 space-y-4">
                {column.items.map((item) => (
                  <li key={item.value}>
                    <a
                      href={item.href}
                      target={item.href.startsWith("http") ? "_blank" : undefined}
                      rel={item.href.startsWith("http") ? "noopener noreferrer" : undefined}
                      className="group flex items-baseline gap-4"
                    >
                      <span className="label text-white/35 w-[4.5rem] shrink-0">
                        {item.label}
                      </span>
                      <span className="text-[0.9375rem] text-[color:var(--ink-invert)] transition-colors group-hover:text-gold">
                        {item.value}
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}

          <motion.div {...reveal(2)} className="md:col-span-4">
            <img
              src={images.hyphenlogo}
              alt="Hyphen Tech"
              loading="lazy"
              width="120"
              height="36"
              className="w-28 h-auto object-contain brightness-0 invert opacity-90"
            />
            <p className="font-heading text-xl leading-snug text-white/70 mt-6 max-w-[24ch]">
              {t("Engineering tomorrow's solutions, today.")}
            </p>
            <p className="label text-white/35 mt-6">Bujumbura, Burundi</p>
          </motion.div>
        </div>
      </div>

      {/* ── Colophon ── */}
      <div className="border-t border-[color:var(--rule-invert)]">
        <div className="shell py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/45">
            &copy; <span className="tabular">{new Date().getFullYear()}</span>{" "}
            Hyphen Tech. {t("All rights reserved.")}
          </p>
          <p className="label text-white/35">
            {t("Empowering Success Through Technology")}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
